export const citiesNavDropdowns = props => (
    {
        create: [
            {
                heading: props.t('presentProject'),
                name: props.t('createEvent'),
                href: 'https://www.sportnect.com/admin/events/create',
                reactLink: false,
                target: '_blank',
                icon: 'sn-event',
                additionalIcon: 'sn-circle-plus',
            },
            {
                name: props.t('createClubAndGroup'),
                href: 'https://www.sportnect.com/admin/clubs/create',
                reactLink: false,
                target: '_blank',
                icon: 'sn-group',
                additionalIcon: 'sn-circle-plus',
            },
            {
                name: props.t('createSportVenue'),
                href: 'https://www.sportnect.com/admin/sport-venues/create',
                reactLink: false,
                target: '_blank',
                icon: 'sn-sportfield',
                additionalIcon: 'sn-circle-plus',
            },
        ],
        menu: [
            {
                heading: props.t('forOrganisers'),
                name: props.t('eventsManagement'),
                href: 'https://www.sportnect.com/admin/events',
                reactLink: false,
                target: '_blank',
                icon: 'sn-event',
                additionalIcon: 'sn-manage',
            },
            {
                name: props.t('clubsAndGroupsManagement'),
                href: 'https://www.sportnect.com/admin/clubs',
                reactLink: false,
                target: '_blank',
                icon: 'sn-group',
                additionalIcon: 'sn-manage',
            },
            {
                name: props.t('hotnewsManagement'),
                href: 'https://www.sportnect.com/admin/posts',
                reactLink: false,
                target: '_blank',
                icon: 'sn-hotnews',
                additionalIcon: 'sn-manage',
            },
            {
                name: props.t('sportVenuesManagement'),
                href: 'https://www.sportnect.com/admin/sport-venues',
                reactLink: false,
                target: '_blank',
                icon: 'sn-sportfield',
                additionalIcon: 'sn-manage',
            },
            {
                name: props.t('tournamentsManagement'),
                href: 'https://tournaments.sportnect.com',
                reactLink: false,
                target: '_blank',
                icon: 'sn-cup',
                additionalIcon: 'sn-manage',
            },
            {
                heading: props.t('me'),
                name: props.t('sportnections'),
                href: 'https://www.sportnect.com/sportnections',
                reactLink: false,
                target: '_blank',
                icon: 'sn-logo-sn',
                additionalIcon: 'sn-avatar',
            },
            {
                name: props.t('personalSettings'),
                href: 'https://www.sportnect.com/admin/me',
                reactLink: false,
                target: '_blank',
                icon: 'sn-manage',
                additionalIcon: 'sn-avatar',
            },
        ],
        landing: [
            {
                name: props.t('whyProjectName'),
                href: '/proc-sportnect',
                reactLink: true,
            },
            {
                name: props.t('aboutUs'),
                href: '/o-nas',
                reactLink: true,
            },
            {
                name: props.t('media'),
                href: '/media',
                reactLink: true,
            },
            {
                name: props.t('cities'),
                href: '/mesta',
                reactLink: true,
            },
        ],
    }
)
